import { HttpClient } from '@angular/common/http';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { PricingService } from 'src/app/service/pricing.service';
import { WebConfigurationService } from 'src/app/web-configuration-module/web-configuration.service';
import { EmailRatesComponent } from '../email-rates/email-rates.component';

@Component({
  selector: 'app-mortgage-pricer-original-template',
  templateUrl: './mortgage-pricer-original-template.component.html',
  styleUrls: ['./mortgage-pricer-original-template.component.scss']
})
export class MortgagePricerOriginalTemplateComponent implements OnInit {

  @Input() mortgagePricerRef: any;
  @Input() refId = '65e78384ce8ad00001f21a2d';

  @Input() loanPurpose: string = null;
  @Input() propertyUse: string = null;
  @Input() propertyType: string = null;
  @Input() preferredAmortization: string = null;
  @Input() fico: number = null;
  @Input() zip: string = null;
  @Input() homeValue: number = null;
  @Input() amount: number = null;
  @Input() lockDays: number = null;
  @Input() secondLoanOption: boolean = null;
  @Input() escrowWaiver: boolean = null;
  @Input() secondLoanAmount: number = null;
  @Input() showVA: boolean = null;
  @Input() unit: number = null;
  @Input() computePropertyTax: boolean = null;
  @Input() searchLabel = 'View Rates';
  @Input() downPayment: number = null;
  @Input() firstTimeHomeBuyer: boolean = true;
  @Input() loanType: string = null;
  @Input() title = 'Discover your Perfect Mortgage Rate';
  @Input() description = 'Find the best mortgage rates tailored to your needs in just a few clicks. <br/> Start by entering your details below to explore your options!';
  @Input() showPersonalizedQuote = true;
  @Input() lpSupportEmail = '';

  search: any;
  loanPurposes = [
    { id: 'Purchase', label: 'Purchase' },
    { id: 'Refinance', label: 'Refinance' },
    // {
    //   id: 'StreamLineRefinance', label: 'StreamLine Refinance',
    //   from: ['UsdaRural', 'FHA', 'VA']
    // },
    // { id: 'CashoutRefinance', label: 'Cashout refinance' }
  ];
  propertyUses = [
    { id: 'PrimaryResidence', label: 'Primary Residence' },
    { id: 'SecondaryVacation', label: 'Secondary Residence' },
    { id: 'Investment', label: 'Investment (NOO)' }
  ];
  loanTypes = [
    { id: 'Fixed', label: 'Fixed' },
    { id: 'Variable', label: 'Variable' },
    // { id: 'Conventional', label: 'Conventional' }
  ];
  ficoRange = [
    { id: 760, label: '760+' },
    { id: 740, label: '740 - 759' },
    { id: 720, label: '720 - 739' },
    { id: 700, label: '700 - 719' },
    { id: 680, label: '680 - 699' },
    { id: 660, label: '660 - 679' },
    { id: 640, label: '640 - 659' },
    { id: 620, label: '620 - 639' },
    { id: 600, label: '600 - 619' },
    { id: 580, label: '580 - 599' },
    { id: 560, label: '560 - 579' }

  ];
  zipCodeSearch: string;
  result: any[][] = [];
  loading = false;
  resultsLoading = true;
  selectedTab: number = 0;
  tabs: string[] = ['30Y Fixed', '15Y Fixed', 'FHA', 'VA'];
  sliderValue: number = 15;
  matchingZipList = [];
  zipCodeSelected = {};
  zipCodeSearchPlusCity: string;
  counties = [];
  loadingCounty = false;
  templateType = 'topDown'; // topDown
  templateTypeExpanded = true;
  selectedLoanPurpose = 'Purchase';

  contact = {
    propertyAddress: {
      state: '',
      street: '',
      streetCont: '',
      city: '',
      zip: '',

    },
    firstname: '',
    lastname: '',
    email: '',
    phone: ''
  };
  countySelected = {};
  selectedLoanCriteria: any;
  bsModalRef: BsModalRef;
  emailSent = false;

  isMobileView: boolean = false;

  constructor(private pricingService: PricingService,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private modalService: BsModalService,
    private configurationService: WebConfigurationService) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.refId = params.refId;
      this.title = params.title ? params.title : this.title;
      this.description = params.description ? params.description : this.description
      this.loanPurpose = params.loanPurpose ? params.loanPurpose : null;
      this.propertyUse = params.propertyUse ? params.propertyUse : null;
      this.propertyType = params.propertyType ? params.propertyType : null;
      this.downPayment = params.downPayment ? params.downPayment : null;
      this.firstTimeHomeBuyer = params.firstTimeHomeBuyer ? !!params.firstTimeHomeBuyer : null;
      this.preferredAmortization = params.preferredAmortization ? params.preferredAmortization : null;
      this.zip = params.zip ? params.zip : null;
      this.homeValue = params.homeValue ? parseInt(params.homeValue, 10) : null;
      this.amount = params.amount ? parseInt(params.amount, 10) : null;
      this.searchLabel = params.searchLabel ? params.searchLabel : this.searchLabel;
      this.loanType = params.loanType ? params.loanType : null;
      this.selectedLoanPurpose = this.loanPurpose;
      this.templateType = params.templateType ? params.templateType : 'topDown';
      this.lpSupportEmail = params.lpSupportEmail ? params.lpSupportEmail : '';
      const primary = params.primaryColor ? `#${params.primaryColor}` : '';
      const secondary = params.secondaryColor ? `#${params.secondaryColor}` : '';
      if(params['showPersonalizedQuote']) {
        this.showPersonalizedQuote = params.showPersonalizedQuote === 'true';
      }

      this.updateTheme(primary, secondary);
    });
    this.checkScreenWidth();
  }

  @HostListener('window:resize', [])
  onResize() {
    this.checkScreenWidth();
  }

  checkScreenWidth() {
    this.isMobileView = window.innerWidth < 768; // Set threshold for mobile
  }

  updateTheme(primary: string, secondary: string): void {
    document.documentElement.style.setProperty('--primary-color', primary);
    document.documentElement.style.setProperty('--secondary-color', secondary);
  }

  ngOnInit() {
    this.searchRates();
  }

  // Function to switch active tab
  setActiveTab(index: number): void {
    this.selectedTab = index;
  }

  updateSlider(event: Event, isInput = false) {
    if (!isInput) {
      this.sliderValue = (event.target as HTMLInputElement).valueAsNumber;
    }
    this.updateDownPayment();
  }

  // Update Down Payment when Slider is moved
  updateDownPayment() {
    this.search.downPayment = (this.search.homeValue * this.sliderValue) / 100;
    this.updateLoanAmount();
  }

  updateLoanAmount() {
    this.search.amount = this.search.homeValue - this.search.downPayment;
  }

  // Update Slider when Down Payment input is changed
  updatePercentage() {
    this.sliderValue = (this.search.downPayment / this.search.homeValue) * 100;
    this.updateLoanAmount();
  }

  onLoanAmountChange() {
    this.search.downPayment = this.search.homeValue - this.search.amount;
  }

  ucFirstAllWords( str )
  {
    str = str.toLowerCase();
    let pieces = str.split(' ');
    for (let i = 0; i < pieces.length; i++)
    {
      var j = pieces[i].charAt(0).toUpperCase();
      pieces[i] = j + pieces[i].substr(1);
    }
    return pieces.join(' ');
  }

  getCountyDataByState(callback: (data) => void, errCallback: (err) => void) {
    this.http.get(
      this.configurationService.configuration.ppeApi
      + 'constant/countys?stateCode=' + this.search.state + '&year=' + new Date().getFullYear()).pipe(
    )
      .subscribe(
        data => callback(data),
        err => errCallback(err),
        () => console.log('request completed')
      );
  }

  getCountyList() {
    this.getCountyDataByState(data => {
        this.counties = [];
          let mapTest = {};
          for (let i in data) {
            if (mapTest[(data[i]['stateFips'].length === 1 ? '0' + data[i]['stateFips']: data[i]['stateFips']) + data[i]['countyFips']]) {
              continue;
            }
            mapTest[(data[i]['stateFips'].length === 1 ? '0' + data[i]['stateFips'] : data[i]['stateFips']) + data[i]['countyFips']] = true;
            var c = {
              code: (data[i]['stateFips'].length === 1 ? '0' + data[i]['stateFips'] : data[i]['stateFips']) + data[i]['countyFips'],
              name: this.ucFirstAllWords(data[i]['countyName']),
              displayName: this.ucFirstAllWords(data[i]['countyDisplayName'])
            };
            if (this.zipCodeSelected['countyFps'] === c.code) {
              this.countySelected = c;
              this.changeCounty();
            }
            this.counties.push(c);
          }
          this.loadingCounty = false;
      },
      err => {
      });
  }

  changeCity() {
    this.contact.propertyAddress.city = this.zipCodeSelected['primary_city'];
    this.contact.propertyAddress.state = this.zipCodeSelected['state'];
    this.contact.propertyAddress.zip = this.zipCodeSelected['zip'];
    this.search.city = this.zipCodeSelected['primary_city'];
    if (this.search.state != this.zipCodeSelected['state'] || this.counties.length === 0) {
      this.search.state = this.zipCodeSelected['state'];
      this.getCountyList();
    }
  }

  changeCounty() {
    this.search.countyFips = this.countySelected['code'];
  }

  searchForZip(zip, firstLoad=false) {
    if (zip && zip.length === 5) {
      this.search.zip = zip;
      this.getDetailInfoFromZipCode(zip, data => {
        this.matchingZipList = data;
        if (data && data.length > 0) {
          this.zipCodeSelected = data[0];
          this.zipCodeSearchPlusCity = zip;
          this.zipCodeSearch = zip;
          // this.search.city = this.zipCodeSelected['primary_city'];
          // if (this.search.state != this.zipCodeSelected['state'] || this.counties.length === 0) {
          //   this.search.state = this.zipCodeSelected['state'];
          // }
          this.changeCity();
        }
        if (firstLoad) {
          this.triggerSearch();
        }
      },
        err => {
          console.error(err);
        });
    }
  }

  getDetailInfoFromZipCode(zipCode: string, callback: (data) => void, errCallback: (err) => void) {
    this.http.get(
      this.configurationService.configuration.ppeApi
      + 'constant/zip/listMiniPricer/' + zipCode).pipe(
    )
      .subscribe(
        data => callback(data),
        err => errCallback(err),
        () => console.log('request completed')
      );
  }

  searchRates() {
    this.loading = true;
    this.search = null;
    this.pricingService.getSearch(this.refId).toPromise()
      .then(ref => {
        this.mortgagePricerRef = ref;
        this.search = ref.miniPricerPref.search;
        this.search.preferredAmortization = 'Fixed';
        this.search.secondLoanAmount = 0;
        this.search.cashoutAmount = 0;
        this.search.loanPurpose = this.loanPurpose === null ? this.search.loanPurpose : this.loanPurpose;
        this.search.propertyUse = this.propertyUse === null ? this.search.propertyUse : this.propertyUse;
        this.search.propertyType = this.propertyType === null ? this.search.propertyType : this.propertyType;
        this.search.preferredAmortization = this.loanType === null ?
          this.search.preferredAmortization : this.loanType;
        this.search.fico = this.fico === null ? this.search.fico : this.fico;
        this.search.zip = this.zip === null ? this.search.zip : this.zip;
        this.search.homeValue = this.homeValue === null ? this.search.homeValue : this.homeValue;
        this.search.amount = this.amount === null ? this.search.amount : this.amount;
        this.search.lockDays = this.lockDays === null ? this.search.lockDays : this.lockDays;
        this.search.secondLoanOption = this.secondLoanOption === null ? this.search.secondLoanOption : this.secondLoanOption;
        this.search.escrowWaiver = this.escrowWaiver === null ? this.search.escrowWaiver : this.escrowWaiver;
        this.search.secondLoanAmount = this.secondLoanAmount === null ? this.search.secondLoanAmount : this.secondLoanAmount;
        this.search.firstTimeHomeBuyer = this.firstTimeHomeBuyer === null ? this.search.showVA : !!this.firstTimeHomeBuyer;
        this.search.unit = this.unit === null ? this.search.unit : this.unit;
        this.sliderValue = this.search.downPercent;
        this.search.downPayment = this.downPayment === null ? ((this.search.homeValue * this.search.downPercent) / 100) : this.downPayment;
        this.updatePercentage();
        this.updateDownPayment();
        this.searchForZip(this.zip, true);
        // this.triggerSearch();
        // this.loading = false;
      })
      .catch(err => {
        this.loading = false;
        console.error(err);
      });
  }

  triggerSearch() {
    const searchLoanPurpose = this.mortgagePricerRef.miniPricerPref.search.loanPurpose
    if ('miniPricerPref' in this.mortgagePricerRef) {
      if ('originalSearch' in this.mortgagePricerRef.miniPricerPref) {
        if ('loanPurposeCriteria' in this.mortgagePricerRef.miniPricerPref.originalSearch) {
          if (this.mortgagePricerRef.miniPricerPref.originalSearch.loanPurposeCriteria.length > 0) {
            if (this.mortgagePricerRef.miniPricerPref.originalSearch.loanPurposeCriteria !== searchLoanPurpose) {
              this.mortgagePricerRef.miniPricerPref.originalSearch.loanPurposeCriteria = [searchLoanPurpose]
            }
            this.mortgagePricerRef.miniPricerPref.search.loanPurposeCriteria = [searchLoanPurpose]
          } else {
            this.mortgagePricerRef.miniPricerPref.search.loanPurposeCriteria = [searchLoanPurpose]
          }
        } else {
          this.mortgagePricerRef.miniPricerPref.search.loanPurposeCriteria = [searchLoanPurpose]
        }
        this.mortgagePricerRef.miniPricerPref.originalSearch.property.address.zip = this.search.zip;
        this.mortgagePricerRef.miniPricerPref.originalSearch.criteria.purchasePrice = this.search.homeValue;
        this.mortgagePricerRef.miniPricerPref.originalSearch.criteria.downPaymentAmount = this.search.downPayment;
        this.mortgagePricerRef.miniPricerPref.originalSearch.criteria.fico = this.search.fico;
        this.mortgagePricerRef.miniPricerPref.originalSearch.criteria.propertyUse = this.search.propertyUse;
        this.mortgagePricerRef.miniPricerPref.originalSearch.criteria.loanType = this.search.preferredAmortization
        this.mortgagePricerRef.miniPricerPref.originalSearch.loanPurposeCriteria = [this.search.loanPurpose];
        this.mortgagePricerRef.miniPricerPref.originalSearch.criteria.firstTimeHomeBuyer = this.search.firstTimeHomeBuyer;
        this.mortgagePricerRef.miniPricerPref.originalSearch.criteria.cashoutAmount = this.search.cashoutAmount;
        this.mortgagePricerRef.miniPricerPref.originalSearch.criteria.loanAmount = this.search.amount;
      }
    }

    this.resultsLoading = true;
    this.result = [];
    this.pricingService.search(this.mortgagePricerRef).toPromise()
      .then(data => {
        this.result = data;
        this.resultsLoading = false;
        this.loading = false;
      })
      .catch(err => {
        console.error(err);
        this.resultsLoading = false;
        this.loading = false;
      });
  }

  closeModal() {
    this.bsModalRef.hide();
  }

  emailRate() {
    const initialState: any = {
      refId: this.refId,
      contact: this.contact,
      showBackButton: false,
    };
    this.bsModalRef = this.modalService.show(EmailRatesComponent,
      {
        class: 'modal-xl',
        animated: true,
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
        initialState
      }
    );
    this.bsModalRef.content.emailNowEmitter.subscribe((contact) => {
      this.emailNow(contact);
    });

    this.bsModalRef.content.backEmitter.subscribe(() => {
        console.log('Closing modal...');
        this.closeModal();
        this.emailSent = false;
    });
  }

  emailNow(contact: any) {
    this.selectedLoanCriteria = this.search.loanCriterias[this.selectedTab];
    const payload = {
      ref: this.refId,
      contact,
      search: this.search,
      loanCriteria: this.selectedLoanCriteria,
      results: this.result[this.selectedTab]
    };

    this.pricingService.sendEmail(payload).toPromise()
    .then(data => {
      this.result = data;
      this.bsModalRef.content.showThankYou = true;
      this.loading = false;
    })
    .catch(err => {
      this.emailSent = false;
      console.error(err);
      this.loading = false;
    });

  }


}
